import { combineReducers } from 'redux'

import AppReducer from '@/ducks/app/slices/app.slice'
import AuthReducer from '@/ducks/auth/slice/auth.slice'
import loginThrottleReducer from '@/ducks/auth/slice/loginThrottle.slice'
import MenuReducer from '@/ducks/menu/slices/menu.slice'
import NotificationsReducer from '@/ducks/notifications/slices/notification.slice'
import OrdersReducer from '@/ducks/orders/slices/orders.slice'
import { rootApi } from '@/ducks/root.api'
import StoreReducer from '@/ducks/store/slice/store.slice'

export const reducers = {
  [rootApi.reducerPath]: rootApi.reducer,
  app: AppReducer,
  auth: AuthReducer,
  notifications: NotificationsReducer,
  orders: OrdersReducer,
  store: StoreReducer,
  menu: MenuReducer,
  loginThrottle: loginThrottleReducer
}

const rootReducer = combineReducers(reducers)

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
